module.exports = __webpack_public_path__ + "img/KM211.223.df86bb66.png";